import React from 'react';
import contentfulRenderOptions from '../../../utils/contentfulRenderOption';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

// Utils //
import rawToReact from "../../../utils/rawToReact";

// Styles //
import "./noContentMessage.scss";

interface noContentMessageProps {
    title: string;
    subtitle: any;
    className?: string;
    imagenPrincipal: {
        gatsbyImageData: {
            images: {
                sources: {
                    srcSet: string;
                    type: string;
                    sizes: string;
                }[];
            };
        };
        description: string;
    } | null;
}

const NoContentMessage = ({ title, subtitle, className, imagenPrincipal }: NoContentMessageProps) => {

    const firstImage = imagenPrincipal && imagenPrincipal.length > 0 ? imagenPrincipal[0] : null;
    const imageSrc = firstImage ? getImage(firstImage.gatsbyImageData) : null;

    return (
        <div className={`m-noContentMessage ${className ? className : ""}`}>
            <div className='m-noContentMessage__text'>
                <p>
                    <strong>{title}</strong>
                    {subtitle && rawToReact(subtitle.raw, contentfulRenderOptions)}
                </p>
            </div>
            {imageSrc && (
                <>
                    <GatsbyImage className="m-noContentMessage__image" image={imageSrc} alt={firstImage?.description || 'default description'} aria-hidden="true" />
                </>
            )}
        </div>
    )
}

export default NoContentMessage;